export default __webpack_public_path__ + "static/media/adopt.44281eec.png";